/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigUnauthorizedResponse,
  SpotRateResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Spot Rate Details
 */
export const getSpotRate = (signal?: AbortSignal) => {
  return customInstance<SpotRateResponseResponse>({
    url: `/BboBranchConfigService/v1/spot-rate`,
    method: 'get',
    signal,
  });
};

export const getGetSpotRateQueryKey = () => {
  return [`/BboBranchConfigService/v1/spot-rate`] as const;
};

export const getGetSpotRateQueryOptions = <
  TData = Awaited<ReturnType<typeof getSpotRate>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpotRate>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSpotRateQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpotRate>>> = ({ signal }) =>
    getSpotRate(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSpotRate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSpotRateQueryResult = NonNullable<Awaited<ReturnType<typeof getSpotRate>>>;
export type GetSpotRateQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Spot Rate Details
 */
export const useGetSpotRate = <
  TData = Awaited<ReturnType<typeof getSpotRate>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpotRate>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSpotRateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
